import { Injectable } from '@angular/core';
import { ExamStudent } from '../exam/interfaces/calendar-event.interface';
import { TreeNode } from 'primeng/api/treenode';
import { ISiteUserTreeModel } from 'src/app/shared/interfaces/restrictions-site';

export class NodeData {
  id: string;
  isChecked: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UsersRestrictionService {
  private selectedNodes: string[] = [];
  private changeUnlockCode = false;
  private _userData: TreeNode[] = [];

  set userData(value: TreeNode[]) {
    this._userData = value;
  }

  get selectedUsersData(): ExamStudent[] {
    return this.getUserDataFormNodes(this._userData, this.selectedNodes);
  }

  get users(): string[] {
    return this.selectedNodes;
  }

  get unlockCode(): boolean {
    return this.changeUnlockCode
  }

  constructor() { }

  addNode(id: string): void {
    if (!this.selectedNodes.find(selectedId => selectedId === id)) {
      this.selectedNodes.push(id);
    }
  }

  removeNode(id: string): void {
    const index = this.selectedNodes.indexOf(id);
    if (index !== -1) {
      this.selectedNodes.splice(index, 1);
    }
  }

  isNodeChecked(id: string): boolean {
    return this.selectedNodes.find(selectedId => selectedId === id) !== undefined;
  }

  reset(): void {
    this.selectedNodes = [];
  }

  setUnlockCodeChange(value: boolean) {
    this.changeUnlockCode = value;
  }

  private getUserDataFromNode(node: ISiteUserTreeModel, selectedIds: string[]): ExamStudent[] {
    const result: ExamStudent[] = [];

    if (!node.children || node.children.length == 0) {
      if (selectedIds.includes(node.id.toString())) {
        result.push({
          userId: node.id.toString(),
          userName: node.userName,
          email: node.email,
          name: node.name,
        });
      }

      return result;
    }

    node.children.forEach(n => {
      const childResult = this.getUserDataFromNode(n, selectedIds)
      result.push(...childResult);
    });

    return result;
  }

  private getUserDataFormNodes(nodes: TreeNode[], selectedIds: string[]): ExamStudent[] {
    const result: ExamStudent[] = [];

    nodes.forEach(n => {
      result.push(...this.getUserDataFromNode(n.data, selectedIds))
    });

    return result;
  }
}
